const afterSaleData = [
    {
        title: "Miễn phí vận chuyển",
        text: "với hoá đơn trên 1.5 triệu ở tất cả các tỉnh thành!",
    },
    {
        title: "Hỗ trợ đổi size",
        text: "tại tất cả các cửa hàng trong vòng 1 tuần!",
    },
];

const checkoutData = [
    {
        link: "/detail/21321",
        thumbnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: 1329000,
        preSalePrice: 1500000,
        color: "red",
        size: 45,
        quantity: 1,
    },
    {
        link: "/detail/21321",
        thumbnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: 132900,
        preSalePrice: 150000,
        color: "red",
        size: 45,
        quantity: 1,
    },
];
const cartProductData = [
    {
        link: "/detail/21321",
        thumbnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: 1329000,
        preSalePrice: 1500000,
        color: "red",
        size: 45,
    },
    {
        link: "/detail/21321",
        thumbnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: 1329000,
        preSalePrice: 1500000,
        color: "red",
        size: 45,
    },
    {
        link: "/detail/21321",
        thumbnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: 1329000,
        preSalePrice: 1500000,
        color: "red",
        size: 45,
    },
    {
        link: "/detail/21321",
        thumbnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: 1329000,
        preSalePrice: 1500000,
        color: "red",
        size: 45,
    },
    {
        link: "/detail/21321",
        thumbnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: 1329000,
        preSalePrice: 1500000,
        color: "red",
        size: 45,
    },
    {
        link: "/detail/21321",
        thumbnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: 1329000,
        preSalePrice: 1500000,
        color: "red",
        size: 45,
    },
];

const userInfo = {
    firstName: "Đỗ",
    lastName: "Bình",
    avatar: "https://www.google.com/url?sa=i&url=https%3A%2F%2Fthatnhucuocsong.com.vn%2Fanh-avatar-dep-hinh-anh-dai-dien-fb-tiktok-zalo%2F&psig=AOvVaw1vT1CYMbx4NZj02VBB8DFO&ust=1679577732553000&source=images&cd=vfe&ved=0CA8QjRxqFwoTCPCWiOPQ7_0CFQAAAAAdAAAAABAE",
    birthday: "15/11/2001",
    gender: "nam",
    phone: "0387655461",
    addresses: [
        {
            id: 1,
            fullName: "Đỗ Bình",
            address: "1270/10/11 Tổ 12 Kp3",
            provinceName: "Tỉnh Đồng Nai",
            districtName: "Thành phố Biên Hòa",
            wardName: "Phường Trảng Dài",
            isDefault: true,
            phone: "012345678",
            email: "dtb751@gmail.com",
            provinceId: "75",
            wardId: "25993",
            districtId: "731",
        },
        {
            id: 2,
            fullName: "Đỗ Bình 2",
            address: "1270/10/11 Tổ 12 Kp3",
            provinceName: "Tỉnh Đồng Nai",
            districtName: "Thành phố Biên Hòa",
            wardName: "Phường Trảng Dài",
            isDefault: false,
            phone: "012345678",
            email: "dtb751@gmail.com",
            provinceId: "75",
            wardId: "25993",
            districtId: "731",
        },
        {
            id: 3,
            fullName: "Đỗ Bình 3",
            address: "1270/10/11 Tổ 12 Kp3",
            provinceName: "Tỉnh Đồng Nai",
            districtName: "Thành phố Biên Hòa",
            wardName: "Phường Trảng Dài",
            isDefault: false,
            phone: "012345678",
            email: "dtb751@gmail.com",
            provinceId: "75",
            wardId: "25993",
            districtId: "731",
        },
        {
            id: 4,
            fullName: "Đỗ Bình 4",
            address: "1270/10/11 Tổ 12 Kp3",
            provinceName: "Tỉnh Đồng Nai",
            districtName: "Thành phố Biên Hòa",
            wardName: "Phường Trảng Dài",
            isDefault: false,
            phone: "012345678",
            email: "",
        },
    ],
};

const colors = [
    { key: "1", code: "Đen" },
    { key: "2", code: "Trắng" },
    { key: "3", code: "Xanh" },
    { key: "4", code: "Đỏ" },
];
const sizes = [
    { key: "1", code: "35" },
    { key: "2", code: "36" },
    { key: "3", code: "37" },
    { key: "4", code: "38" },
    { key: "5", code: "39" },
    { key: "6", code: "40" },
    { key: "7", code: "41" },
    { key: "8", code: "42" },
    { key: "9", code: "43" },
];

const orderBy = [
    { key: "1", code: "Giá tăng dần" },
    { key: "2", code: "Giá giảm dần" },
    { key: "3", code: "Mới nhất " },
    { key: "4", code: "Cũ nhất" },
];
const detailSlide = [
    {
        id: 1,
        imageURL:
            "https://file.hstatic.net/1000230642/file/hunter_x_-_dune_otp_real_f5f808523a944dcab9c5e492c37a9c7a.jpg",
        link: "/collections/hunter-nam",
        title: null,
        createAt: "04-18-2023 10:53:25",
        updateAt: "04-18-2023 10:53:25",
        state: "ACTIVE",
        typeGallery: {
            id: 2,
            typeCode: "slide",
            typeName: "Ảnh slide",
            createAt: "04-17-2023 14:13:12",
            updateAt: "04-17-2023 14:13:12",
            state: "ACTIVE",
        },
    },
    {
        id: 2,
        imageURL:
            "https://file.hstatic.net/1000230642/file/1920x750_gosto_bb0795caa61e4ba5bbf8abbbc047d172.jpg",
        link: "/collections/gosto-nu",
        title: null,
        createAt: "04-18-2023 10:53:25",
        updateAt: "04-18-2023 10:53:25",
        state: "ACTIVE",
        typeGallery: {
            id: 2,
            typeCode: "slide",
            typeName: "Ảnh slide",
            createAt: "04-17-2023 14:13:12",
            updateAt: "04-17-2023 14:13:12",
            state: "ACTIVE",
        },
    },
    {
        id: 3,
        imageURL:
            "https://file.hstatic.net/1000230642/file/1920x750_hunter_junior_efec6325ab764c66baad7983c098f7b3.jpg",
        link: "/collections/nu",
        title: null,
        createAt: "04-18-2023 10:53:25",
        updateAt: "04-18-2023 10:53:25",
        state: "ACTIVE",
        typeGallery: {
            id: 2,
            typeCode: "slide",
            typeName: "Ảnh slide",
            createAt: "04-17-2023 14:13:12",
            updateAt: "04-17-2023 14:13:12",
            state: "ACTIVE",
        },
    },
];

const productCardData = [
    {
        link: "/detail/21321",
        thumnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: "Giày Thể Thao Nam Hunter X Dune OTP Real Black edition HSM00120N",
        salePrice: "1320000",
        preSalePrice: "1500000",
        totalSize: 5,
        totalColor: 3,
    },
    {
        link: "/detail/21321",
        thumnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: "1329000",
        preSalePrice: "1500000",
        totalSize: 5,
        totalColor: 3,
    },
    {
        link: "/detail/21321",
        thumnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: "1329000",
        preSalePrice: "1500000",
        totalSize: 5,
        totalColor: 3,
    },
    {
        link: "/detail/21321",
        thumnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: "1329000",
        preSalePrice: "1500000",
        totalSize: 5,
        totalColor: 3,
    },
    {
        link: "/detail/21321",
        thumnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: "1329000",
        preSalePrice: "1500000",
        totalSize: 5,
        totalColor: 3,
    },
    {
        link: "/detail/21321",
        thumnailBefore:
            "https://product.hstatic.net/1000230642/product/hsm001200den__2__5b334f3afd484a40bec4abe17b476c8f_grande.jpg",
        thumnailAfter:
            "https://product.hstatic.net/1000230642/product/hsm001200den__10__86abade27eac4056a9713976efd7d034_grande.jpg",
        name: " Giày Thể Thao Nam Hunter X - Dune OTP Real Black edition HSM00120N",
        salePrice: "1329000",
        preSalePrice: "1500000",
        totalSize: 5,
        totalColor: 3,
    },
];
const slideData = [
    {
        id: 1,
        imageURL:
            "https://file.hstatic.net/1000230642/file/hunter_x_-_dune_otp_real_f5f808523a944dcab9c5e492c37a9c7a.jpg",
        link: "/collections/hunter-nam",
        title: null,
        createAt: "04-18-2023 10:53:25",
        updateAt: "04-18-2023 10:53:25",
        state: "ACTIVE",
        typeGallery: {
            id: 2,
            typeCode: "slide",
            typeName: "Ảnh slide",
            createAt: "04-17-2023 14:13:12",
            updateAt: "04-17-2023 14:13:12",
            state: "ACTIVE",
        },
    },
    {
        id: 2,
        imageURL:
            "https://file.hstatic.net/1000230642/file/1920x750_gosto_bb0795caa61e4ba5bbf8abbbc047d172.jpg",
        link: "/collections/gosto-nu",
        title: null,
        createAt: "04-18-2023 10:53:25",
        updateAt: "04-18-2023 10:53:25",
        state: "ACTIVE",
        typeGallery: {
            id: 2,
            typeCode: "slide",
            typeName: "Ảnh slide",
            createAt: "04-17-2023 14:13:12",
            updateAt: "04-17-2023 14:13:12",
            state: "ACTIVE",
        },
    },
    {
        id: 3,
        imageURL:
            "https://file.hstatic.net/1000230642/file/1920x750_hunter_junior_efec6325ab764c66baad7983c098f7b3.jpg",
        link: "/collections/nu",
        title: null,
        createAt: "04-18-2023 10:53:25",
        updateAt: "04-18-2023 10:53:25",
        state: "ACTIVE",
        typeGallery: {
            id: 2,
            typeCode: "slide",
            typeName: "Ảnh slide",
            createAt: "04-17-2023 14:13:12",
            updateAt: "04-17-2023 14:13:12",
            state: "ACTIVE",
        },
    },
];
export {
    afterSaleData,
    cartProductData,
    userInfo,
    checkoutData,
    colors,
    sizes,
    orderBy,
    detailSlide,
    productCardData,
    slideData,
};
